<template>
    <div>
        <settingTemplate
            ref="settingTemplate"
            :templateType="templateType"
            @edit-dialog="openEditDialog"
        />
    </div>
</template>

<script>
import SettingTemplate from "@/components/setting-template/list.vue";

export default {
    components: {
        SettingTemplate
    },
    computed: {
        templateType() {
            /**
             * refer URL for template type, eg:-
             * /view/settings/template/:type/:id
             */
            return this.$route.params.type;
        }
    },
    methods: {
        getRefreshList() {
            this.$refs.settingTemplate.getList();
        },
        openEditDialog(temp) {
            if (temp) {
                this.$emit("open-dialog", temp);
            }
        }
    }
};
</script>
